import React, { useState, useEffect, useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { authenticatedApiCall } from '../../utils/apiClient';

// All tracker_piping columns
const COLUMNS = [
  { key: 'iso_sheet_number', label: 'ISO Sheet #', type: 'text', width: 120 },
  { key: 'line_number', label: 'Line Number', type: 'text', width: 120 },
  { key: 'fluid_code', label: 'Fluid Code', type: 'text', width: 100 },
  { key: 'pnid', label: 'P&ID', type: 'text', width: 100 },
  { key: 'priority', label: 'Priority', type: 'number', width: 80 },
  { key: 'area', label: 'Area', type: 'text', width: 100 },
  { key: 'sub_area', label: 'Sub Area', type: 'text', width: 100 },
  { key: 'system', label: 'System', type: 'text', width: 100 },
  { key: 'sub_system', label: 'Sub System', type: 'text', width: 100 },
  { key: 'size_1', label: 'Size 1', type: 'text', width: 80 },
  { key: 'size_2', label: 'Size 2', type: 'text', width: 80 },
  { key: 'size_3', label: 'Size 3', type: 'text', width: 80 },
  { key: 'material_1', label: 'Material 1', type: 'text', width: 100 },
  { key: 'material_2', label: 'Material 2', type: 'text', width: 100 },
  { key: 'material_3', label: 'Material 3', type: 'text', width: 100 },
  { key: 'schedule_1', label: 'Schedule 1', type: 'text', width: 90 },
  { key: 'schedule_2', label: 'Schedule 2', type: 'text', width: 90 },
  { key: 'length_1', label: 'Length 1', type: 'number', width: 90 },
  { key: 'length_2', label: 'Length 2', type: 'number', width: 90 },
  { key: 'length_3', label: 'Length 3', type: 'number', width: 90 },
  { key: 'um', label: 'UM', type: 'text', width: 60 },
  { key: 'udf_type', label: 'UDF Type', type: 'text', width: 100 },
  { key: 'udf_tag', label: 'UDF Tag', type: 'text', width: 100 },
  { key: 'udf_qty', label: 'UDF Qty', type: 'number', width: 80 },
  { key: 'fabrication_shop', label: 'Fab Shop', type: 'text', width: 120 },
  { key: 'load_number', label: 'Load #', type: 'text', width: 100 },
  { key: 'total_shop_completion', label: 'Shop %', type: 'number', width: 80, isProgress: true },
  { key: 'date_shipped', label: 'Date Shipped', type: 'date', width: 110 },
  { key: 'received', label: 'Received %', type: 'number', width: 90, isProgress: true },
  { key: 'transport_to_installation_area', label: 'Transport %', type: 'number', width: 100, isProgress: true },
  { key: 'erect_supports_hangers', label: 'Erect %', type: 'number', width: 80, isProgress: true },
  { key: 'fit_up', label: 'Fit Up %', type: 'number', width: 80, isProgress: true },
  { key: 'bolt_up_weld', label: 'Bolt/Weld %', type: 'number', width: 90, isProgress: true },
  { key: 'line_cleanup_hydro_test', label: 'Hydro %', type: 'number', width: 80, isProgress: true },
  { key: 'insulation', label: 'Insulation %', type: 'number', width: 100, isProgress: true },
  { key: 'heat_tracing', label: 'Heat Trace %', type: 'number', width: 100, isProgress: true },
  { key: 'budget_hours', label: 'Budget Hrs', type: 'number', width: 100 },
  { key: 'budget_cost_cad', label: 'Budget CAD', type: 'number', width: 110 },
  { key: 'budget_dia_in', label: 'Budget DIA', type: 'number', width: 100 },
  { key: 'budget_credit', label: 'Budget Credit', type: 'number', width: 100 },
  { key: 'earned_hours_shop', label: 'Earned Hrs Shop', type: 'number', width: 120 },
  { key: 'earned_field_cost_cad', label: 'Earned Field CAD', type: 'number', width: 130 },
  { key: 'earned_field_dollars', label: 'Earned Field $', type: 'number', width: 110 },
  { key: 'shop_field_ratio', label: 'Shop/Field Ratio', type: 'number', width: 110 },
  { key: 'activity_name', label: 'Activity Name', type: 'text', width: 150 },
  { key: 'activity_id', label: 'Activity ID', type: 'text', width: 100 },
  { key: 'fab_activity_name', label: 'Fab Activity Name', type: 'text', width: 150 },
  { key: 'fab_activity_id', label: 'Fab Activity ID', type: 'text', width: 100 },
  { key: 'baseline_or_extra', label: 'Baseline/Extra', type: 'text', width: 110 },
  { key: 'extra_number', label: 'Extra #', type: 'text', width: 90 },
  { key: 'extra_description', label: 'Extra Desc', type: 'text', width: 150 },
  { key: 'client_wbs', label: 'Client WBS', type: 'text', width: 120 },
  { key: 'lgl_wbs_internal', label: 'LGL WBS', type: 'text', width: 120 },
  { key: 'sov', label: 'SOV', type: 'text', width: 80 },
  { key: 'cost_code', label: 'Cost Code', type: 'text', width: 100 },
  { key: 'client_contract_number', label: 'Contract #', type: 'text', width: 120 },
  { key: 'p6_project_id', label: 'P6 Project ID', type: 'text', width: 120 },
  { key: 'comments', label: 'Comments', type: 'text', width: 200 },
  { key: 'udf01', label: 'UDF01', type: 'text', width: 100 },
  { key: 'udf02', label: 'UDF02', type: 'text', width: 100 },
  { key: 'udf03', label: 'UDF03', type: 'text', width: 100 },
  { key: 'udf04', label: 'UDF04', type: 'text', width: 100 },
  { key: 'udf05', label: 'UDF05', type: 'text', width: 100 },
  { key: 'udf06', label: 'UDF06', type: 'text', width: 100 },
  { key: 'udf07', label: 'UDF07', type: 'text', width: 100 },
  { key: 'udf08', label: 'UDF08', type: 'text', width: 100 },
  { key: 'udf09', label: 'UDF09', type: 'text', width: 100 },
  { key: 'udf10', label: 'UDF10', type: 'text', width: 100 },
];

const TestPipingProgressTracker = ({ projectId, jobNumber }) => {
  const { instance, accounts } = useMsal();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchItems = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await authenticatedApiCall(
        instance,
        accounts,
        'GET',
        `/matrix?project_id=${projectId}`
      );

      if (response.data.success) {
        setItems(response.data.data || []);
      } else {
        setError('Failed to load piping progress data');
      }
    } catch (err) {
      console.error('Error fetching piping data:', err);
      setError('Failed to load data. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [instance, accounts, projectId]);

  useEffect(() => {
    if (projectId) {
      fetchItems();
    }
  }, [fetchItems, projectId]);

  // Filter items based on search
  const filteredItems = items.filter(item => {
    if (!searchTerm.trim()) return true;
    const search = searchTerm.toLowerCase();
    return COLUMNS.some(col => {
      const value = item[col.key];
      return value && String(value).toLowerCase().includes(search);
    });
  });

  // Format cell value for display
  const formatValue = (value, column) => {
    if (value === null || value === undefined || value === '') return '—';
    if (column.type === 'number') {
      if (column.isProgress) {
        return `${value}%`;
      }
      return typeof value === 'number' ? value.toLocaleString() : value;
    }
    if (column.type === 'date') {
      try {
        return new Date(value).toLocaleDateString();
      } catch {
        return value;
      }
    }
    return value;
  };

  // Get cell background color for progress columns
  const getProgressColor = (value) => {
    if (value === null || value === undefined) return 'transparent';
    const num = parseFloat(value);
    if (isNaN(num)) return 'transparent';
    if (num >= 100) return '#d1fae5';
    if (num >= 75) return '#fef3c7';
    if (num >= 50) return '#fed7aa';
    if (num > 0) return '#fecaca';
    return 'transparent';
  };

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #dc2626',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem'
        }}></div>
        <p>Loading piping progress data...</p>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#dc2626' }}>
        <p>{error}</p>
        <button 
          onClick={fetchItems}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: '1rem' }}>
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '1rem',
        flexWrap: 'wrap',
        gap: '1rem'
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '1.5rem', color: '#1a1a1a' }}>
            🧪 Test - Piping Progress Tracker
          </h2>
          <p style={{ margin: '0.25rem 0 0', color: '#666', fontSize: '0.9rem' }}>
            Showing {filteredItems.length} of {items.length} rows • {COLUMNS.length} columns
          </p>
        </div>
        
        {/* Search */}
        <input
          type="text"
          placeholder="Search all columns..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: '0.5rem 1rem',
            border: '1px solid #ddd',
            borderRadius: '6px',
            width: '250px',
            fontSize: '0.9rem'
          }}
        />
      </div>

      {/* Table Container */}
      <div style={{ 
        overflow: 'auto', 
        maxHeight: 'calc(100vh - 200px)',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        backgroundColor: 'white'
      }}>
        <table style={{ 
          width: 'max-content',
          borderCollapse: 'collapse',
          fontSize: '0.8rem'
        }}>
          <thead>
            <tr style={{ 
              backgroundColor: '#1a1a1a',
              position: 'sticky',
              top: 0,
              zIndex: 10
            }}>
              <th style={{
                padding: '0.75rem 0.5rem',
                color: 'white',
                fontWeight: '600',
                textAlign: 'center',
                borderRight: '1px solid #333',
                position: 'sticky',
                left: 0,
                backgroundColor: '#1a1a1a',
                zIndex: 11,
                width: '50px'
              }}>
                #
              </th>
              {COLUMNS.map(col => (
                <th 
                  key={col.key}
                  style={{
                    padding: '0.75rem 0.5rem',
                    color: 'white',
                    fontWeight: '600',
                    textAlign: 'left',
                    borderRight: '1px solid #333',
                    whiteSpace: 'nowrap',
                    minWidth: col.width
                  }}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredItems.map((item, rowIndex) => (
              <tr 
                key={item.id || rowIndex}
                style={{ 
                  backgroundColor: rowIndex % 2 === 0 ? '#fff' : '#f9fafb',
                  borderBottom: '1px solid #e5e7eb'
                }}
              >
                <td style={{
                  padding: '0.5rem',
                  textAlign: 'center',
                  borderRight: '1px solid #e5e7eb',
                  position: 'sticky',
                  left: 0,
                  backgroundColor: rowIndex % 2 === 0 ? '#fff' : '#f9fafb',
                  fontWeight: '500',
                  color: '#666'
                }}>
                  {rowIndex + 1}
                </td>
                {COLUMNS.map(col => (
                  <td 
                    key={col.key}
                    style={{
                      padding: '0.5rem',
                      borderRight: '1px solid #e5e7eb',
                      whiteSpace: 'nowrap',
                      maxWidth: '200px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      backgroundColor: col.isProgress ? getProgressColor(item[col.key]) : 'inherit'
                    }}
                    title={item[col.key] ? String(item[col.key]) : ''}
                  >
                    {formatValue(item[col.key], col)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        
        {filteredItems.length === 0 && (
          <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
            {searchTerm ? 'No matching records found.' : 'No data available.'}
          </div>
        )}
      </div>
    </div>
  );
};

export default TestPipingProgressTracker;










